import { render, staticRenderFns } from "./MarriageRecord.vue?vue&type=template&id=5d3b04ac&"
import script from "./MarriageRecord.vue?vue&type=script&lang=js&"
export * from "./MarriageRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports